import type { ExtractedAuditorCommentColumns } from './auditorCommentsDrawer.types';

export const AUDITOR_COMMENTS_COLUMN_LABELS = {
    YEAR: 'Year',
    AUDITOR_DETAILS: 'Auditor Details',
    AUDITOR_COMMENTS: 'Auditor’s Comments',
    DIRECTOR_COMMENTS: 'Director’s Comments',
};

export const AUDITOR_COMMENTS_DRAWER_TITLE = 'Auditor Comments';

export const QUALIFICATION_LABELS = {
    QUALIFIED: 'Qualified / Reservations / Adverse Remarks',
    NOT_QUALIFIED: 'No Qualified / Reservations / Adverse Remarks',
};

export const NO_DATA_LABEL = 'No Data Available';

export const ADDITIONAL_AUDITORS_LABEL = 'Additional Auditors';

export const AUDITOR_TOOLTIP_LABELS = {
    AUDITOR_NAME: 'Auditor Name',
    MEMBERSHIP_NO: 'Auditor Membership No',
    FIRM_NAME: 'Firm Name',
    FRN: 'Firm Registration ID',
    PAN: 'Auditor/Firm PAN',
    ADDRESS: 'Auditor Address',
};

export const FOOTNOTE_LABEL = 'Footnote:';

export const EMPTY_COMMENT_COLUMNS: Readonly<ExtractedAuditorCommentColumns> = {
    auditorComments: [],
    directorComments: [],
    auditorFootnotes: [],
    directorFootnotes: [],
};

export const FETCHING_LATEST_DATA_LABEL = 'Fetching latest data (takes upto 24 hours)';

export const FETCH_FAILED_LABEL = 'Not able to fetch data';

export const AUDITOR_COMMENTS_DRAWER_PARAM = 'auditorComments';
